import React, { useState } from "react";
import { Sparkles } from "lucide-react";

/**
 * BlogCover — renders a blog post's cover image with a graceful gradient +
 * title fallback if the cover fails to load (broken URL, 404, slow generation).
 * Keeps the aspect ratio the parent asks for so layout never shifts.
 */
export const BlogCover = ({ src, title, ratio = "16/9", className = "" }) => {
    const [errored, setErrored] = useState(false);
    const showImg = !!src && !errored;

    return (
        <div
            className={`w-full overflow-hidden bg-[hsl(var(--muted))] ${className}`}
            style={{ aspectRatio: ratio }}
            data-testid="blog-cover"
        >
            {showImg ? (
                <img
                    src={src}
                    alt={title || ""}
                    loading="lazy"
                    onError={() => setErrored(true)}
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                />
            ) : (
                <div
                    className="w-full h-full grid place-items-center p-6 text-center"
                    style={{
                        background:
                            "linear-gradient(135deg, rgba(179,108,255,0.28) 0%, rgba(10,255,176,0.22) 55%, rgba(34,211,238,0.22) 100%)",
                    }}
                >
                    <div className="flex flex-col items-center gap-3 max-w-[85%]">
                        <Sparkles className="w-8 h-8 text-white/85" />
                        {title ? (
                            <div className="font-display font-bold text-white/90 text-base md:text-lg leading-snug line-clamp-3">
                                {title}
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    );
};

export default BlogCover;
